<template>
  <div class="home">
    <div style="display: none">
      <img
        src="@/assets/img/logo.jpg"
        alt=""
      />
    </div>
    <div class="header">
      <div class="w padding flex">
        <span>FinLLM 2023</span>
        <div class="right">
          <img
            src="@/assets/img/ijcai.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="subtitle padding w">
      <div class="sub-text">
        International Symposium on <br />Large Language Models for Financial Services<br />
        (FinLLM 2023)@IJCAI 2023
      </div>
      <button
        class="registration"
        @click="$router.push('/fcb')"
      >
        List of Awards
      </button>
      <!-- <div class="sub-img">
        <img
          src="@/assets/img/subImg.png"
          alt=""
        />
      </div> -->
    </div>
    <div class="center-box w padding">
      <div class="center-img-box">
        <div class="center-text-box">
          <div class="center-text-content">
            <div class="center-text-top">
              <span class="center-text-title">Symposium Date: <br /></span>
              <span class="center-text-body">August 20, 2023 <br /></span>
            </div>
            <span class="center-text-title">Venue: <br /></span>
            <span class="center-text-body">Sheraton Grand Macao Hotel,Macau</span>
          </div>
        </div>
        <img
          class="center-img"
          src="@/assets/img/hotel.jpg"
        />
      </div>
      <!-- <h1>Committee</h1> -->
      <h1>Scope and Objective</h1>
      <div class="cente-text mg-bottom">
        Pretrained large language models (LLMs) have demonstrated tremendous potential in various natural language
        processing tasks, including language generation, machine translation, and question answering. In the financial
        services industry, pretrained LLMs have the potential to significantly impact tasks such as financial
        forecasting, risk management, and sentiment analysis. Moreover, LLMs can help automate the process of analyzing
        financial reports and extracting key insights that can aid businesses in making informed decisions.<br /><br />
        This symposium provides a platform for researchers, practitioners, and industry experts from around the world to
        share new ideas, exchange research findings, and discuss the challenges and opportunities in the field of
        pretrained LLMs for financial services. The symposium will cover two themes: 1) potential applications and best
        practices of pretrained LLMs for financial services; and 2) challenges that need to be addressed to make them
        efficient, effective, and trustworthy. <br /><br />
        The symposium will also feature invited talks by leading researchers and industry experts, as well as panel
        discussions on the latest trends and challenges in the field. We welcome researchers, practitioners, and
        industry experts from academia and industry to submit their work and participate in this exciting event.
      </div>
      <h1>Call for Papers</h1>
      <div class="cente-text mg-bottom">
        <div class="cente-text-title">
          We welcome submissions on recent advances and applications of large language models (LLMs) in financial
          services. We encourage submissions that cover a wide range of topics, including but not limited to:
        </div>
        <div class="cente-text-cente flex">
          <div class="text">
            <span>Techniques: </span>
            <br />-Multimodal modeling of financial data using LLMs <br />-Preprocessing and cleaning of financial data
            for use with LLMs <br />-Integration of LLMs with other AI technologies in financial services <br />-Novel
            architectures and training techniques for LLMs in financial services. <br />-Scalability and efficiency of
            LLMs in financial services <br />-Cross-lingual and multilingual LLMs in financial services
            <br />-Human-in-the-loop approaches for LLMs in financial services <br /><br /><span>Applications:</span
            ><br />
            -Financial forecasting using LLMs <br />-Sentiment analysis and opinion mining for financial data
            <br />-LLM-based trading algorithms and decision-making systems <br />-Analysis of financial news and social
            media using LLMs <br />-Semantic analysis of financial reports and filings <br />-Explainable AI in
            financial services using LLMs <br />-Transfer learning and domain adaptation for LLMs in financial services
            <br />-Case studies and success stories of LLMs in financial services <br /><br /><span>Challenges:</span
            ><br />
            -Evaluation of LLMs for financial services <br />-Social economics and trustworthiness for LLMs in financial
            services <br />-Ethical and legal considerations in the use of LLMs in financial services <br />-Privacy and
            security concerns in the use of LLMs for financial data <br />-Bias and fairness considerations in the use
            of LLMs for financial services
          </div>
          <div class="img-box">
            <img
              src="@/assets/img/IMG.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <h1>Important Dates</h1>
      <div class="card-box mg-bottom">
        <div class="card">
          <p class="title">Submission Due:</p>
          <p class="timer">
            <span class="month">June 20, 2023</span>
            <span class="date">(23:59:59 AoE)</span>
          </p>
        </div>
        <div class="card">
          <p class="title">Notification Due:</p>
          <p class="timer">
            <span class="month">July 4, 2023</span>
            <span class="date">(23:59:59 AoE)</span>
          </p>
        </div>
        <div class="card">
          <p class="title">Final Version Due:</p>
          <p class="timer">
            <span class="month">August 3, 2023</span>
            <span class="date">(23:59:59 AoE)</span>
          </p>
        </div>
        <div class="card">
          <p class="title">Symposium Date:</p>
          <p class="timer">
            <span class="month">August 20, 2023</span>
          </p>
        </div>
      </div>
      <h1>Submission Instructions</h1>
      <div class="cente-text mg-bottom">
        <div class="cente-text-cente justify">
          Submissions should be a maximum of 7 and a minimum of 4 pages including figures and tables in IJCAI'23 format.
          Additional pages containing only cited references are allowed. We do accept submissions of work recently
          published or currently under review. The submissions can contain author details. The Symposium will not have
          formal proceedings, but authors of accepted papers can choose to have their work published on the Symposium
          webpage. Top selected papers from the Symposium will be invited to publish in a journal special issue.
          <br /><br />

          We recommend submitting your paper through EasyChair. The paper submission link is as follows:<br />
          <a href="https://easychair.org/conferences/?conf=finllm2023">
            https://easychair.org/conferences/?conf=finllm2023</a
          >
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="w padding">
        <h1>Tentative Schedule</h1>
        <div>
          <div class="middle-mg">
            <span>Morning:</span>
            <br />• 08:30 - 09:00 Registeration<br />• 09:00 - 10:00 Invited talks <br />• 10:00 - 10:45 Oral
            presentations <br />• 10:45 - 11:00 Break <br />• 11:00 - 11:45 Oral presentations
          </div>
          <div>
            <span>Afternoon:</span>
            <br />• 13:00 - 14:30 Invited talks <br />• 14:30 - 15:15 Oral presentations <br />• 15:15 - 15:30 Break
            <br />• 15:30 - 16:30 Panel Discussion <br />• 16:30 - 17:00 Award Ceremony
          </div>
        </div>
      </div>
    </div>
    <div class="center-box w padding">
      <h1>Organization</h1>
      <div class="item-box">
        <!-- <div class="item-box-left">
          <p>Symposium Organizers:</p>
          <div>
            -Shuoling Liu (E Fund) <br />-Xueyang Wu (Flaiverse) <br />-Yongpeng Tang (E Fund) <br />-Qian Xu (HKUST)
            <br />-Liyuan Chen (E Fund) <br />-Qiang Yang (WeBank/HKUST, Hong Kong)
          </div>
        </div> -->
        <div class="item-box-right">
          <p>Invited Speakers</p>
          <div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/Mark Dredze.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Mark Dredze(online)</p>
                <p class="note">Bloomberg</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/白硕.jpg"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Shuo Bai</p>
                <p class="note">Hundsun Technologies</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/王巍巍.jpg"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Weiwei Wang</p>
                <p class="note">Alibaba DAMO Academy</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/皱胜.jpg"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Sheng Zou</p>
                <p class="note">Archforce Technology</p>
              </div>
            </div>
            <!-- 1.Shijie Wu (Bloomberg) <br />2.Bai Shuo (Chief Senior Technical Advisor of the Intelligent Investment
            Research Technology) <br />3.Zhong Yuyang (Chief Information Officer of China Southern Asset Management)
            <br />4.Sun Jianing (General Manager of both the Quantitative Investment Department and Equity Research
            Department at Guotai Junan Securities Asset Management) <br />5.Jinlong Li (Director of the AI Laboratory of
            China Merchants Bank) <br />6.Jie Tang (Tsinghua University) <br />7.Xiaoyan Liu (President of E Fund)
            <br />8.Kar Yan Tam (Dean of HKUST Business School) <br />9.Sau San Chan (Chairman of the Monetary Authority
            of Macao) <br />10.Eddie Yue (Chief Executive of the Hong Kong Monetary Authority) <br />11.Jie He (Head of
            the Shenzhen Local Financial Supervision and Administration Bureau) <br />12.Ravi Menon (Managing Director
            of the Monetary Authority of Singapore) -->
          </div>
        </div>
      </div>
      <p><br /></p>
      <h1>Organizers of Organizing Committee</h1>
      <div class="cente-text mg-bottom">
        <div class="centet-people">
          <div class="left-title">General Chair</div>
          <div class="people-box">
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/7.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Qiang Yang</p>
                <p class="note">WeBank/HKUST</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/9.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Liyuan Chen</p>
                <p class="note">E Fund</p>
              </div>
            </div>
          </div>
        </div>
        <div class="centet-people">
          <div
            class="left-title"
            style="text-align: left"
          >
            Chairman of the Program Committee
          </div>
          <div class="people-box">
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/6.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Shuoling Liu</p>
                <p class="note">E Fund</p>
              </div>
            </div>
          </div>
        </div>
        <div class="centet-people">
          <div class="left-title">Program Chair</div>
          <div class="people-box">
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/xueyangWu.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Xueyang Wu</p>
                <p class="note">Flaiverse</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/yongpeng tang.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Yongpeng Tang</p>
                <p class="note">E Fund</p>
              </div>
            </div>
            <div class="info-box">
              <div class="avt">
                <img
                  src="@/assets/img/qianxu.png"
                  alt=""
                />
              </div>
              <div class="info">
                <p class="name">Qian Xu</p>
                <p class="note">HKUST</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cente-text mg-bottom">
        <div class="cente-text-cente justify">
          <span>Qiang Yang: </span>
          Chief AI Officer of WeBank, Department Head of Computer Science and Engineering at the Hong Kong University of
          Science and Technology, New Bright Professorship in Engineering. AAAI Fellow, IEEE Fellow, AAAS Fellow, IAPR
          Fellow and ACM Distinguished Members. President of IJCAI (2017-2019). Vice Chair of ACM SIGART (SIGAI)
          (2009-2012), PC Chair and Co-Chair: IJCAI(2015), ACM KDD(2010).<br />
          Google Scholar: <br /><a href="https://scholar.google.com/citations?user=1LxWZLQAAAAJ"
            >https://scholar.google.com/citations?user=1LxWZLQAAAAJ</a
          ><br /><br />
          <span>Liyuan Chen: </span>
          Chief Operating Officer of E Fund Management, Chairman of the E Fund FinTech Executive Committee.<br /><br />
          <span>Shuoling Liu: </span>
          Head of Institute of Innovation at E Fund Management, Secretary-General of E Fund FinTech Executive Committee,
          Member of the FinTech Special Committee of AMAC. <br /><br />
          <span>Xueyang Wu: </span>
          PhD, HKUST (2023), Co-founder & Principal Scientist at Flaiverse. Research interests: transfer learning,
          federated learning, NLP, LLMs. Publications: research papers & patents. Reviewer: NeurIPS, KDD, ICML, ICLR,
          etc. <br /><br />
          <span>Yongpeng Tang: </span>
          MD, Head of Application Development at E Fund Management, Member of E Fund Fintech Executive Committee, Senior
          FinTech expert. <br /><br />
          <span>Qian Xu: </span>
          PhD, HKUST (2011), Adjunct Associate Professor at HKUST(GZ). Research interests: AI, transfer learning,
          federated learning, NLP, LLMs. Experience at Baidu Inc. & Webank Inc. Executive Director of GSAIR & Founding
          Member of GBA Society of AI and Robotics.
        </div>
      </div>
      <h1>The Main Conference Information</h1>
      <div class="cente-text mg-bottom">
        <div class="cente-text-cente">
          IJCAI 2023, <br />THE 32nd INTERNATIONAL JOINT CONFERENCE ON ARTIFICIAL INTELLIGENCE. <br />19th-25th August
          2023 <br />Macao, S.A.R <br />
          <a href="https://ijcai-23.org/">https://ijcai-23.org/</a>
        </div>
      </div>
    </div>
    <div class="footer padding">
      <div>
        <div class="email-icon"></div>
        <div class="email-info">
          <p>If you have any question, feel free to contact us:</p>
          <p style="color: #b3ebff">yanjiangpeng@efunds.com.cn</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
@import '../../style/public.less';
.padding {
  padding: 0 130px;
}
.w {
  min-width: 1715px;
  max-width: 1920px;
  margin: 0 auto;
}
.mg-bottom {
  margin-bottom: 50px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header,
.footer {
  min-width: 1715px;
  height: 103px;
  line-height: 103px;
  font-size: 28px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  background: url('@/assets/img/CTA.png') no-repeat;
  background-size: cover;
  .right {
    width: 172px;
    height: 64px;
    @media (max-width: 750px) {
      width: 300px;
      height: 120px;
    }
    img {
      width: 100%;
      height: 100%;
      vertical-align: top;
    }
  }
}
.footer {
  height: 151px;
  margin-top: 100px;
  font-size: 20px;
  color: #ffffff;
  font-weight: 500;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    .email-icon {
      width: 30px;
      height: 30px;
      margin-right: 9px;
      background: url('@/assets/img/email.png') no-repeat;
      background-size: cover;
    }
    p {
      margin: 0;
      line-height: 1.5;
    }
  }
}
.subtitle {
  background: url('@/assets/img/header-bg.jpg') no-repeat;
  height: 614px;
  box-sizing: border-box;
  background-size: 100% 100%;
  // display: flex;
  // justify-content: space-between;
  padding-top: 144px;
  @media (max-width: 750px) {
    height: 1200px;
  }
  .sub-text {
    font-size: 43px;
    color: #ffffff;
    line-height: 60px;
    font-weight: 700;
    margin-top: 50px;
    @media (max-width: 750px) {
      font-size: 80px;
      line-height: 1.5;
    }
  }
  .sub-img {
    width: 300px;
    height: 434px;
    flex-shrink: 0;
    @media (max-width: 750px) {
      width: 330px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .registration {
    width: 150px;
    height: 50px;
    background-color: #4270f1;
    border: none;
    color: #ffffff;
    margin-top: 20px;
    font-size: 16px;
    cursor: pointer;
    @media (max-width: 750px) {
      width: 300px;
      height: 100px;
      font-size: 28px;
    }
  }
}
.center-box {
  h1 {
    font-size: 48px;
    color: #0d152e;
    line-height: 60px;
    font-weight: 700;
    &::before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 40px;
      background-color: #4774f4;
      margin-right: 10px;
      vertical-align: baseline;
    }
  }

  .center-img-box {
    display: flex;
    margin-top: 72px;
    margin-bottom: 32px;
    width: 100%;
    background-color: #299bff;
    @media (max-width: 750px) {
      flex-direction: column;
      border-radius: 20px;
      padding: 80px 0;
    }

    .center-text-box {
      border-color: transparent;
      color: #ffffff;
      border-radius: 15px 0 0 15px;
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 750px) {
        width: 100%;
        justify-content: start;
        padding-left: 30px;
        font-size: 42px;
      }

      .center-text-top {
        margin-bottom: 12px;
        @media (max-width: 750px) {
          margin-bottom: 20px;
        }
      }

      .center-text-title {
        font-weight: 600;
        font-size: 32px;
      }

      .center-text-body {
        font-weight: 400;
        font-size: 24px;
      }
    }

    @media (max-width: 750px) {
      margin-top: -250px;
      .center-text-content {
        margin-left: 24px;
        @media (max-width: 750px) {
          span {
            font-size: 50px !important;
          }
        }
      }
    }

    .center-img {
      flex-grow: 1;
      border-radius: 0 15px 15px 0;
      border-left: 1px solid #20b9e1;
      height: 320px;
      @media (max-width: 750px) {
        width: 100%;
        height: auto;
        margin-top: 30px;
      }
    }
  }
  .cente-text {
    font-size: 20px;
    color: #81838c;
    text-align: justify;
    line-height: 34px;
    font-weight: 500;
    .centet-people {
      display: flex;
      align-items: center;
      margin-top: 40px;
      @media (max-width: 750px) {
        display: block;
      }
      .left-title {
        font-size: 24px;
        color: #0078ce;
        font-weight: 700;
        width: 280px;
        @media (max-width: 750px) {
          width: auto;
          font-size: 42px;
          margin-bottom: 20px;
        }
      }
      .people-box {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .info-box {
          display: flex;
          align-items: center;
          width: 25%;
          @media (max-width: 750px) {
            width: 50%;
            margin-bottom: 40px;
          }
          .avt {
            width: 90px;
            height: 90px;
            margin-right: 20px;
            background: rgba(95, 95, 95, 0.16);
            border-radius: 50%;
            // border: 1px solid #e2e2e2;
            overflow: hidden;
            @media (max-width: 750px) {
              width: 180px;
              height: 180px;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .xuqian {
            width: 100px;
            height: 90px;
          }
          @media (max-width: 750px) {
            .xuqian {
              width: 200px;
              height: 180px;
            }
          }
          .info {
            p {
              margin: 0;
            }
            .name {
              font-size: 19.8px;
              color: #292f36;
              font-weight: 700;
              @media (max-width: 750px) {
                font-size: 42px;
              }
            }
            .note {
              font-size: 16.2px;
              color: #292f36;
              font-weight: 500;
              text-align: left;
              @media (max-width: 750px) {
                font-size: 32px;
              }
            }
          }
        }
      }
    }
    .cente-text-title {
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 34px;
    }
    .cente-text-cente {
      text-align: left;
      span {
        font-size: 26px;
        font-weight: 700;
      }
      .img-box {
        width: 620px;
        @media (max-width: 750px) {
          display: none;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .justify {
      text-align: justify;
    }
    .cente-footer {
      margin-top: 34px;
    }
    .p-text {
      font-size: 26px;
      font-weight: 700;
    }
  }
  .card-box {
    display: flex;
    justify-content: space-between;
    .card {
      width: 285px;
      height: 156px;
      background: #f7f9fb;
      border-radius: 23px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      p {
        margin: 0;
      }
      .title {
        font-size: 20px;
        color: #81838c;
        line-height: 33px;
        font-weight: 700;
      }
      .timer {
        color: #81838c;
        .month {
          font-size: 20px;
          font-weight: 500;
        }
        .date {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
  .item-box {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    color: #81838c;
    text-align: justify;
    line-height: 34px;
    font-weight: 500;
    .item-box-left {
      width: 50%;
      background: url('@/assets/img/IMG.png') no-repeat;
      background-size: contain;
      text-align: left;
      p {
        font-size: 26px;
        font-weight: 700;
      }
    }
    .item-box-right {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > p {
        width: 280px;
        @media (max-width: 750px) {
          font-size: 42px !important;
          width: auto;
        }
      }
      @media (max-width: 750px) {
        display: block;
      }
      & > div {
        display: flex;
        flex: 1;
        justify-content: space-between;
        // margin-left: 120px;
        @media (max-width: 750px) {
          // margin-left: 40px;
          flex-wrap: wrap;
          margin-top: 40px;
        }
        .info-box {
          display: flex;
          align-items: center;
          width: 25%;
          @media (max-width: 750px) {
            width: 50%;
            margin-bottom: 40px;
          }
          .avt {
            width: 90px;
            height: 90px;
            margin-right: 20px;
            background: rgba(95, 95, 95, 0.16);
            border-radius: 50%;
            // border: 1px solid #e2e2e2;
            overflow: hidden;
            @media (max-width: 750px) {
              width: 180px;
              height: 180px;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          .xuqian {
            width: 100px;
            height: 90px;
          }
          @media (max-width: 750px) {
            .xuqian {
              width: 200px;
              height: 180px;
            }
          }
          .info {
            flex: 1;
            p {
              margin: 0;
            }
            .name {
              font-size: 19.8px;
              color: #292f36;
              font-weight: 700;
              @media (max-width: 750px) {
                font-size: 42px;
              }
            }
            .note {
              font-size: 16.2px;
              color: #292f36;
              font-weight: 500;
              text-align: left;
              @media (max-width: 750px) {
                font-size: 32px;
              }
            }
          }
        }
        // & > div {
        //   width: 90px;
        //   // background: url('@/assets/img/rect.png') no-repeat;
        //   // background-size: cover;
        //   // display: flex;
        //   // align-items: center;
        //   display: flex;
        //   align-items: center;
        //   color: #ffffff;
        //   // overflow: hidden;
        //   @media (max-width: 750px) {
        //     width: 180px;
        //   }
        //   & > div {
        //     font-size: 26px;
        //     color: #292f36;
        //     font-weight: 600;
        //     text-align: center;
        //     &.img-box {
        //       // height: 90px;
        //       border-radius: 50%;
        //       overflow: hidden;
        //       margin-bottom: 10px;
        //       // @media (max-width: 750px) {
        //       //   height: 180px;
        //       // }
        //     }
        //     @media (max-width: 750px) {
        //       font-size: 42px;
        //     }
        //   }
        //   img {
        //     width: 100%;
        //     height: 100%;
        //   }
        //   @media (max-width: 750px) {
        //     width: 180px;
        //     height: 180px;
        //     margin-top: 40px;
        //   }
        //   @media (max-width: 375px) {
        //     width: 200px;
        //     height: 200px;
        //     margin-top: 40px;
        //   }
        // }
        // @media (max-width: 750px) {
        //   .isH5 {
        //     display: none;
        //   }
        // }
      }
      p {
        font-size: 26px;
        font-weight: 700;
        margin: 0;
        color: #0078ce;
      }
    }
    .bg-none {
      background: none;
    }
  }
  .h1-title {
    margin-top: 50px;
    font-size: 26px;
    color: #81838c;
    line-height: 34px;
    font-weight: 700;
  }
}
.middle {
  min-width: 1715px;
  height: 544px;
  background: url('@/assets/img/CTA.png') no-repeat;
  background-size: cover;
  padding-top: 72px;
  margin-bottom: 50px;
  & > div {
    h1 {
      font-size: 48px;
      color: #ffffff;
      line-height: 60px;
      font-weight: 700;
      margin-bottom: 50px;
      &::before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 40px;
        background-color: #ffffff;
        margin-right: 10px;
        vertical-align: baseline;
      }
    }
    & > div {
      display: flex;
      & > div {
        font-size: 27px;
        color: #ffffff;
        line-height: 45.9px;
        font-weight: 500;
        span {
          font-size: 35px;
          font-weight: 700;
        }
      }
    }
    .middle-mg {
      margin-right: 309px;
    }
  }
}
@media (max-width: 750px) {
  .header,
  .footer,
  .middle {
    min-width: 375px;
  }
  .header {
    height: 200px;
    line-height: 200px;
    font-size: 80px;
  }
  .w {
    min-width: 100vw;
    max-width: 100vw;
  }
  .center-box {
    .cente-text {
      line-height: 50px;
    }
    .item-box {
      line-height: 60px;
      display: block;
      .item-box-left,
      .item-box-right {
        width: 100%;
        text-align: left;
      }
      .item-box-left {
        margin-bottom: 30px;
        background-position-x: 700px;
      }
      .media-bottom {
        margin-bottom: 0;
      }
    }
    .card-box {
      flex-wrap: wrap;
      .card {
        width: 49%;
        margin-bottom: 30px;
        .title {
          margin-bottom: 20px;
        }
      }
    }
  }
  .middle {
    height: auto;
    padding: 72px 0;
    & > div {
      .middle-mg {
        margin: 0;
      }
      & > div {
        display: unset;
        & > div {
          line-height: 60px;
        }
      }
    }
  }
}
/* 针对 Firefox 浏览器 */
@supports (-moz-appearance: none) {
  @media (max-width: 750px) {
    .public-mixin();
  }
}
/* 针对 iOS 设备，Retina 屏幕 */
@media screen and (-webkit-min-device-pixel-ratio: 2) and (max-width: 750px) {
  .public-mixin();
}

/* 针对 iOS 设备，非 Retina 屏幕 */
@media screen and (-webkit-max-device-pixel-ratio: 1) and (max-width: 750px) {
  .public-mixin();
}

/* 针对特定的 iOS 设备（例如：iPhone 6/7/8 Plus） */
@media screen and (device-aspect-ratio: 16/9) and (-webkit-min-device-pixel-ratio: 3) and (max-width: 750px) {
  .public-mixin();
}
</style>
